import React from 'react';
import { Heart } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-8 border-t border-white/10 backdrop-blur-lg">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="mb-4 md:mb-0">
            <p className="text-gray-400 flex items-center space-x-2">
              <span>© {currentYear} {personalInfo.name}.</span>
              <span>All rights reserved.</span>
            </p>
          </div>
          <div className="flex items-center space-x-2 text-gray-400">
            <span>Built with</span>
            <Heart className="w-4 h-4 text-red-400 fill-red-400" />
            <span>using React & TailwindCSS</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;